export default angular.module('GeoDataPrintApp', [
            'KhBase'
        ]);
